import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Advertise() { return <StaticPageRedirect page="advertise" />; }
